unable to read source [project]/node_modules/src/native-bar-code-detector.ts